import darkIcon from '@/assets/dark_icon_transparent_background.svg'
import { getEnvironmentConfig } from '@/config/environmentBranding'
import { Menu, Settings } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useAuth } from '@/hooks/useAuth'
import UserMenu from '../user/UserMenu'
import { SettingsPanel } from './SettingsPanel'

interface HeaderProps {
  onMobileMenuToggle: () => void
}

export default function Header({ onMobileMenuToggle }: HeaderProps) {
  const { user } = useAuth()
  const envConfig = getEnvironmentConfig()
  const [isSettingsPanelOpen, setIsSettingsPanelOpen] = useState(false)
  const [headerHeight, setHeaderHeight] = useState(72)

  const toggleSettingsPanel = () => {
    setIsSettingsPanelOpen(!isSettingsPanelOpen)
  }

  useEffect(() => {
    const measureHeader = () => {
      const header = document.querySelector('header')
      if (header) {
        setHeaderHeight(header.offsetHeight)
      }
    }

    measureHeader()
    window.addEventListener('resize', measureHeader)

    return () => window.removeEventListener('resize', measureHeader)
  }, [])

  return (
    <>
      <header className="bg-white z-10">
        <div className="px-4 sm:px-6 lg:px-8 h-[72px] flex items-center justify-between border-b border-gray-200">
          <div className="flex items-center">
            {/* Mobile menu button */}
            <button
              type="button"
              className="md:hidden text-gray-500 hover:text-gray-600 focus:outline-none"
              onClick={onMobileMenuToggle}
            >
              <Menu className="h-6 w-6" />
            </button>

            {/* Logo area with skew effect - matches CD header pattern */}
            <div className="ml-2 md:ml-0 flex items-center h-8 pr-8 relative">
              <div className="relative img-wrapper absolute after:content-[''] after:absolute after:top-0 after:left-0 after:w-full after:h-full after:skew-x-[-20deg] after:border-r-2 after:border-black/20">
                <span className="text-xl font-bold text-gray-700 px-[0.4rem] pb-[0.2rem] mr-[0.1rem]">
                  {envConfig.shortLabel}
                </span>
              </div>
              <img src={darkIcon} alt="Profylr" className="pl-[0.4rem] h-6 object-contain" />
            </div>

          </div>

          <div className="flex items-center space-x-4">
            {/* Welcome message */}
            {user && (user.firstName || user.email) && (
              <span className="hidden md:inline-block text-sm font-medium text-gray-700">
                Welcome, {user.firstName || user.email?.split('@')[0]}
              </span>
            )}

            {/* Settings - toggles settings panel like CD */}
            <button
              onClick={toggleSettingsPanel}
              className="text-gray-600 hover:text-gray-800 focus:outline-none"
            >
              <Settings className="h-5 w-5" />
            </button>

            {/* User profile menu */}
            <UserMenu />
          </div>
        </div>
      </header>

      <SettingsPanel
        isOpen={isSettingsPanelOpen}
        onClose={toggleSettingsPanel}
        headerHeight={headerHeight}
      />
    </>
  )
}
